/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import abstractCaseTranslations from "./abstractCaseTranslations";
import abstractLitigationCaseTranslations from "./abstractLitigationCaseTranslations";

const abstractAdministrativeLitigationCaseTranslations = {
  ...abstractCaseTranslations,
  ...abstractLitigationCaseTranslations,
  administrativeDecisionReceivedDate: {
    label: "Wann haben Sie den Bescheid erhalten?",
    validators: {
      required: "Bitte geben Sie an, wann Sie den Bescheid erhalten haben.",
    },
  },
  extrajudicialCommunicationSent: {
    label: "Wann haben Sie dem Bescheid widersprochen?",
    validators: {
      required: "Bitte geben Sie an, wann Sie dem Bescheid widersprochen haben.",
    },
  },
  administrativeCaseType: {
    expeditedProceeding: {
      label: "Eilverfahren",
    },
    failureToActLawsuit: {
      label: "Untätigkeitsklage",
    },
  },
  authorityName: {
    question: "Wie lautet die Bezeichnung Ihrer Beschäftigungsbehörde / Dienststelle?",
    label: "Name Behörde",
    placeholder: "z. B. Polizeipräsidium Oberbayern Nord, Schulamt Köln, Bundesamt für Migration und Flüchtlinge, Justizvollzugsanstalt Tegel.",
    validators: {
      required: "Bitte geben sie die Bezeichnung Ihrer Beschäftigungsbehörde / Dienststelle an.",
    },
  },
  employerMunicipality: {
    question: "In welcher Kommune / Stadt / Gemeinde sind Sie beschäftigt?",
    label: "Dienstherr Kommune / Stadt / Gemeinde",
    placeholder: "z. B. Stadt Dortmund, Landkreis Emsland, Gemeinde Sylt",
    helperText: "z. B. Bitte geben Sie die offizielle Bezeichnung Ihres Dienstherrn an (z. B. Stadt, Gemeinde oder Landkreis).",
    validators: {
      required: "Bitte geben Sie an in welcher Kommune / Stadt / Gemeinde Sie beschäftigt sind.",
    },
  },
  authorityAddress: {
    headline: "Anschrift der Behörde / Dienststelle",
    label: "Anschrift der Behörde / Dienststelle",
  },
  authorityTelephone: {
    label: "Telefon Behörde",
    validators: {
      required: "Bitte geben sie die Telefonnummer Ihrer Beschäftigungsbehörde / Dienststelle an.",
    },
  },
  employerType: {
    question: "Bei welchem Dienstherrn sind Sie beschäftigt?",
    label: "Dienstherr",
    options: {
      federal: {
        label: "Bund (Bundesbeamter)",
      },
      state: {
        label: "Land (Landesbeamter)",
      },
      municipal: {
        label: "Kommune / Stadt / Gemeinde",
      },
    },
    validators: {
      required: "Bitte wählen Sie eine der angezeigten Antworten aus.",
    },
  },
  employerState: {
    question: "In welchem Bundesland sind Sie beschäftigt?",
    label: "Dienstherr Bundesland",
    validators: {
      required: "Bitte wählen Sie ein Bundesland aus der Liste aus.",
    },
    options: {
      BW: {
        label: "Baden-Württemberg (BW)",
      },
      BY: {
        label: "Bayern (BY)",
      },
      BE: {
        label: "Berlin (BE)",
      },
      BB: {
        label: "Brandenburg (BB)",
      },
      HB: {
        label: "Bremen (HB)",
      },
      HH: {
        label: "Hamburg (HH)",
      },
      HE: {
        label: "Hessen (HE)",
      },
      MV: {
        label: "Mecklenburg-Vorpommern (MV)",
      },
      NI: {
        label: "Niedersachsen (NI)",
      },
      NW: {
        label: "Nordrhein-Westfalen (NW / NRW)",
      },
      RP: {
        label: "Rheinland-Pfalz (RP)",
      },
      SL: {
        label: "Saarland (SL)",
      },
      SN: {
        label: "Sachsen (SN)",
      },
      ST: {
        label: "Sachsen-Anhalt (ST)",
      },
      SH: {
        label: "Schleswig-Holstein (SH)",
      },
      TH: {
        label: "Thüringen (TH)",
      },
    },
  },
};

export default abstractAdministrativeLitigationCaseTranslations;
